import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [

      {
        path: "/login",
        name: "login",
        component: resolve => require(["@/views/login"], resolve)
      },
      {
        path: "/rolePage",
        name: "rolePage",
        component: resolve => require(["@/views/rolePage"], resolve)
      },

      {
        path: "/",
        name: "login",
        component: resolve =>
          require(["@/views/login"], resolve)
      },
      {
        path: "/index",
        name: "index",
        component: resolve => require(["@/views/index"], resolve),
        children: [
          {
            path: "/",
            name: "liveMessage",
            component: resolve =>
              require(["@/views/liveMessage/liveMessage"], resolve)
          },
          {
            path: "liveMessage",
            name: "实时消息",
            component: resolve =>
              require(["@/views/liveMessage/liveMessage"], resolve)
          },
          {
            path: "liveMessage/liveMegDetail",
            name: "实时消息详情",
            component: resolve =>
              require(["@/views/liveMessage/liveMegDetail"], resolve)
          },





          {
            path: "meetingTheRepairOrder",
            name: "会议工单",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/meetingTheRepairOrder"], resolve)
          },
          {
            path: "meetingTheRepairOrder/addWorkOrder",
            name: "新建工单",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/addWorkOrder"], resolve)
          },
          {
            path: "meetingTheRepairOrder/editWorkOrder",
            name: "修改工单",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/editWorkOrder"], resolve)
          },
          {
            path: "meetingTheRepairOrder/meetTurn",
            name: "会议变更",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/meetTurn"], resolve)
          },
          {
            path: "meetingTheRepairOrder/detailWorkOrder",
            name: "工单详情",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/detailWorkOrder"], resolve)
          },
          {
            path: "meetingTheRepairOrder/beforeMeeting",
            name: "会前工作",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/beforeMeeting"], resolve)
          },
          {
            path: "meetingTheRepairOrder/duringMeeting",
            name: "会中工作",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/duringMeeting"], resolve)
          },
          {
            path: "meetingTheRepairOrder/afterMeeting",
            name: "会后工作",
            component: resolve =>
              require(["@/views/meetingTheRepairOrder/afterMeeting"], resolve)
          },




          {
            path: "dataStatistics",
            name: "数据统计",
            component: resolve =>
              require(["@/views/dataStatistics/dataStatistics"], resolve)
          },

          {
            path: "roomConfiguration",
            name: "会议室配置",
            component: resolve =>
              require(["@/views/roomConfiguration/roomConfiguration"], resolve)
          },
          {
            path: "roomConfiguration/roomConfigurAdd",
            name: "新增会议室配置",
            component: resolve =>
              require(["@/views/roomConfiguration/roomConfigurAdd"], resolve)
          },
          {
            path: "roomConfiguration/roomConfigurDetail",
            name: "会议室配置详情",
            component: resolve =>
              require(["@/views/roomConfiguration/roomConfigurDetail"], resolve)
          },
          {
            path: "roomConfiguration/roomConfigurEdit",
            name: "会议室配置编辑",
            component: resolve =>
              require(["@/views/roomConfiguration/roomConfigurEdit"], resolve)
          },

          {
            path: "userManagement",
            name: "用户管理",
            component: resolve =>
              require(["@/views/userManagement/userManagement"], resolve)
          },
          {
            path: "authorityManagement",
            name: "权限管理",
            component: resolve =>
              require(["@/views/authorityManagement/authorityManagement"], resolve)
          },
        ]
      },
  ]
  
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js